// extracted by mini-css-extract-plugin
export default {"menu":"ControlButtonMenu_menu__xol3F","button":"ControlButtonMenu_button__BZUsc"};